import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TrainingDetailsPage } from './training-details';

@NgModule({
  declarations: [
    TrainingDetailsPage,
  ],
  imports: [
    IonicPageModule.forChild(TrainingDetailsPage),
  ],
})
export class TrainingDetailsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/training-details/training-details.module.ts